import React from "reactn";
import PropTypes from "prop-types";

// components
import DeliveryAddress from "./delivery_address/DeliveryAddress";

const AddressWrapper = props => {
    const { handleChange, handleKeyup, values, errors, handleBlur } = props;

    return (
        <>
            <DeliveryAddress handleChange={handleChange} handleKeyup={handleKeyup} handleBlur={handleBlur} values={values} errors={errors} title="Delivery Address"></DeliveryAddress>
        </>
    );
};

AddressWrapper.propTypes = {
    handleChange: PropTypes.func,
    handleKeyup: PropTypes.func,
    handleBlur: PropTypes.func,
    values: PropTypes.object,
    errors: PropTypes.object,
};

export default AddressWrapper;